module.exports = __webpack_public_path__ + "static/media/top_left.858233c5.png";